import {
    GET_FESTIVAL_DETAILS, 
    GET_FESTIVAL_DETAILS_SUCCEEDED, 
    GET_FESTIVALS, GET_FESTIVALS_SUCCEEDED, 
    ADD_FESTIVAL_TO_FAVORITE,
    REMOVE_FESTIVAL_FROM_FAVORITE, 
    GET_FESTIVAL_LOCATIONS, 
    GET_FESTIVAL_LOCATIONS_SUCCEEDED, 
    GET_EVENTS, 
    GET_EVENTS_SUCCEEDED, 
    ADD_EVENT_TO_FAVORITE, 
    REMOVE_EVENT_FROM_FAVORITE, 
    GET_EVENT_DETAILS, 
    GET_EVENT_DETAILS_SUCCEEDED
} from "./types";


export const getFestivalDetails = (payload) => ({
    type: GET_FESTIVAL_DETAILS,
    payload,
});

export const getFestivalDetailsSucceeded = (payload) => ({
    type: GET_FESTIVAL_DETAILS_SUCCEEDED,
    payload,
});

export const getFestivals = (payload) => ({
    type: GET_FESTIVALS,
    payload
})

export const getFestivalsSucceeded = (payload) => ({
    type: GET_FESTIVALS_SUCCEEDED,
    payload
})

export const addFestivalToFavorite = (payload) => ({
    refresh: true,
    type: ADD_FESTIVAL_TO_FAVORITE,
    payload
})

export const removeFestivalFromFavorite = (festivalId, payload) => ({
    refresh: true,
    type: REMOVE_FESTIVAL_FROM_FAVORITE,
    festivalId,
    payload
})

export const getFestivalLocations = (payload) => ({
    type: GET_FESTIVAL_LOCATIONS,
    payload
})

export const getFestivalLocationsSucceeded = (payload) => ({
    type: GET_FESTIVAL_LOCATIONS_SUCCEEDED,
    payload
})

export const getEvents = (payload) => ({
    type: GET_EVENTS,
    payload
})

export const getEventsSucceeded = (payload) => ({
    type: GET_EVENTS_SUCCEEDED,
    payload
})

export const addEventToFavorite = (payload) => ({
    refresh: true,
    type: ADD_EVENT_TO_FAVORITE,
    payload
})

export const removeEventFromFavorite = (payload) => ({
    refresh: true,
    type: REMOVE_EVENT_FROM_FAVORITE,
    payload
})

export const getEventDetails = (payload) => ({
    type: GET_EVENT_DETAILS,
    payload
})

export const getEventDetailsSucceeded = (payload) => ({
    type: GET_EVENT_DETAILS_SUCCEEDED,
    payload
})


// WEBPACK FOOTER //
// ./src/SHARED/actions/festival.actions.js